import { CancelToken } from 'axios';
import { useCallback, useState } from 'react';
import { AvailabilityEnum } from '../ProductTypes';
import { productSearchRepository } from '../repositories/productSearch/productSearch.repository';

type ProductAvailabilitiesProps = {
  cancelToken?: CancelToken;
  productId?: string;
  productColorId?: string;
  orderId?: string;
};

export type ProductAvailabilities = {
  isLoading: boolean;
  availabilities: Array<AvailabilityEnum>;
  getAvailability: () => Promise<void>;
};

const useProductAvailabilities = ({
  cancelToken,
  productId,
  productColorId,
  orderId,
}: ProductAvailabilitiesProps): ProductAvailabilities => {
  const [isLoading, setIsLoading] = useState(true);
  const [availabilities, setAvailabilities] = useState<Array<AvailabilityEnum>>([]);

  const getAvailability = useCallback(async () => {
    if (productId && productColorId) {
      setIsLoading(true);
      const response = await productSearchRepository(cancelToken).getProductSearchAvailability({
        productId,
        productColorId,
        orderId,
      });

      if (response.ok && response.data) {
        setAvailabilities(response.data);
      }
      setIsLoading(false);
      return;
    }

    setIsLoading(false);
    setAvailabilities([]);
  }, [cancelToken, orderId, productColorId, productId]);

  return {
    isLoading,
    availabilities,
    getAvailability,
  };
};
export default useProductAvailabilities;
